/** @module Camunda/ToolbarCompleteTask */
define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/view/ToolbarDropDown",
	"csi/widget/ErrorText",
	"csi/widget/FilteringSelect",
	"csi/widget/TooltipDialog",
	"csi/widget/ValidationTextArea",
	"Camunda"
], function(declare,locale,ToolbarDropDown,ErrorText,FilteringSelect,TooltipDialog,ValidationTextArea,Camunda) {

	return declare(ToolbarDropDown, {
		/** @property {string} taskAction - name of action to invoke */
		taskAction: null,
		
		/** @property {Memory} taskActionStore - store of possible actions to invoke (if taskAction is null) */
		taskActionStore: null,
		
		postCreate: function() {
			const self = this;

			this.inherited(arguments);

			this.dropDown = new TooltipDialog({
				"class": "csi-camunda-complete-task-dialog",
				dialogActions: true,
				submitResource: "SubmitForm",
				
				onBlur: function() {
					this.reset();
				},
				onCreate: function() {
					self._buildDialog(this);
				},
				onSave: function(values) {
					// start action to complete task
					values.action = values.action || self.taskAction;

					self.onClick(null, self.defAction, {
						actionValue: values
					});

					// make sure enable the button again so that it can be able to be access when it fails the first time 
					// "resumeAfterSave" will be called
					return false;
				}
			});
		},
		
		/**
		 * Render widgets for dialog
		 * @param {TooltipDialog} dialog
		 */
		_buildDialog: function(dialog) {
			// render action selection if not fixed to one action
			const store = this.taskActionStore;
			if (store) {
				const select = new FilteringSelect({
					customErrorHandling: true,
					labelAttr: "label",
					labelType: "html",
					name: "action",
					onChange: this._updateCommentBox.bind(this),
					placeHolder: locale.resource("Select"),
					required: true,
					store: store
				});
				dialog.addChild(select);
				dialog.addChild(new ErrorText({
					className: "csi-error-message",
					inputWidget: select
				}));
			}
			
			// render comment
			const box = this._commentBox = new ValidationTextArea({
				customErrorHandling: true,
				missingMessage: locale.resource("CommentIsRequired"),
				name: "comment"
			});
			
			this._updateCommentBox(this.taskAction);

			dialog.addChild(box);
			dialog.addChild(new ErrorText({
				className: "csi-error-message",
				inputWidget: box 
			}));
		},
		
		/**
		 * Update comment box properties based on given action
		 * @param {string} taskAction
		 */
		_updateCommentBox: function(taskAction) {
			const view = this.getView();
			const task = view.getViewNode();
			const w = this._commentBox;

			var commentPlaceholder = "Comment";
			var required = false; 
			var disabled = true;
			
			if (taskAction) {
				if (Camunda.doesTaskActionRequireComments(view.cacheView, task, taskAction)) {
					commentPlaceholder = "CommentRequired";
					required = true;
				} else {
					commentPlaceholder = "CommentOptional";
				}
				
				disabled = false;
			}
				
			w.set("disabled", disabled);
			w.set("placeholder", locale.resource(commentPlaceholder));
			w.set("required", required);
			w.reset();
		}
	});
});